import { Children, isValidElement, type ReactElement, type ReactNode } from "react";

type CaseProps = {
  value: string;
  children: ReactNode;
};

export function Case(_props: CaseProps) {
  return null;
}

Case.displayName = "MiiSwitchCase";

type SwitchProps = {
  value: string;
  children: ReactNode;
};

export function Switch({ value, children }: SwitchProps) {
  let matched: ReactNode = null;
  Children.forEach(children, child => {
    if (!isValidElement(child)) return;
    const el = child as ReactElement<CaseProps>;
    if (el.type === Case && el.props.value === value) {
      matched = el.props.children;
    }
  });
  return <>{matched}</>;
}
